import { useEffect, useState } from 'react'
import {
  Spinner
} from '@wordpress/components';
import { __ } from '@wordpress/i18n';

import './index.css';

export default function RequestLogs() {
  const [showLogs, setShowLogs] = useState(false);

  const [urls, setUrls] = useState<string[]>([]);
  const [successfulUrls, setSuccessfulUrls] = useState([]);
  const [failureUrls, setFailureUrls] = useState([]);
  const [workingUrls, setWorkingUrls] = useState([]);

  useEffect(() => {
    if (!window.APIRequestTracker) return;

    setUrls(window.APIRequestTracker.getRequests());

    const handler = (_: string | null, all: string[]) => {
      setUrls(all);
    };

    const unsubscribe = window.APIRequestTracker.onNewRequest(handler);
    return () => unsubscribe;
  }, []);

  const removeDomain = (url: string) => {
    const urlParts = url.split('/');
    const domain = urlParts[2];
    const path = urlParts.slice(6).join('/');
    return `/${path}`;
  };

  const filterOutValue = (url) => (prev) => prev.filter((u) => u !== url);

  const clearCache = (url: string) => {
    removeFromAllLists(url);
    setWorkingUrls((prev) => [...prev, url]);
    // Request the url with '&nocache=1' appended to the end.
    const newUrl = url.includes('?') ? `${url}&nocache=1` : `${url}?nocache=1`;
    fetch(newUrl, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
    })
      .then((response) => {
        if (response.ok) {
          setSuccessfulUrls((prev) => [...prev, url]);
          removalComplete(url);
        } else {
          console.error(`Failed to clear cache for ${url}`);
          setFailureUrls((prev) => [...prev, url]);
          removalComplete(url);
        }
      })
      .catch((error) => {
        console.error(`Error clearing cache for ${url}:`, error);
      });
  };

  const clearAll = () => {
    urls.forEach((url) => {
      clearCache(url);
    });
  };

  const removalComplete = (url: string) => {
    setWorkingUrls(filterOutValue(url));
    setTimeout(() => {
      removeFromAllLists(url);
    }, 3000);
  };

  const removeFromAllLists = (url: string) => {
    setSuccessfulUrls(filterOutValue(url));
    setFailureUrls(filterOutValue(url));
    setWorkingUrls(filterOutValue(url));
  }

  return (
    <>
      <button
        type="button"
        className="request-logs-button"
        onClick={() => setShowLogs(!showLogs)}
      >
        🐟 {__('Bassmaster TMS API', 'bass-blocks')} ({urls.length})
      </button>
      {showLogs ? (
        <div className="bass-blocks-request-logs__container">
          <h3>{__('API Requests on this Page', 'bass-blocks')}</h3>
          <ul>
            {urls.map((url) => (
              <li key={url}>
                {removeDomain(url)}
                <div className="request-logs__actions">
                  {
                    workingUrls.includes(url) ? (
                      <Spinner />
                    ) : null
                  }
                  {successfulUrls.includes(url) ? (
                    <span>✅</span>
                  ) : null}
                  {failureUrls.includes(url) ? (
                    <span>❌</span>
                  ) : null}
                  <button
                    type="button"
                    className="request-logs-button"
                    onClick={() => {
                      clearCache(url);
                    }}
                    disabled={workingUrls.includes(url)}
                  >
                    {__('Clear', 'bass-blocks')}
                  </button>
                </div>
              </li>
            ))}
          </ul>
          <button
            type="button"
            className="clear-all-button"
            onClick={clearAll}
          >
            {__('Clear All', 'bass-blocks')}
          </button>
        </div>
      ) : null}
    </>
  );
}
